import {Routes} from '@angular/router';
import {HomeComponent} from './home/home.component';
import {base_management_routes} from './base.management/base.management.routes';
import {saleManagementRoutes} from './sale.management/sale.management.routes';
import {wholesaleManagementRoutes} from "./wholesale.management/wholesale.management.routes";
import {shopsaleManagementRoutes} from "./shopsale.management/shopsale.management.routes";
import {wholesaleposManagementRoutes} from "./wholesalepos.management/wholesalepos.management.routes";

export const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    data: {title: '首页'},
    children: [
      ...base_management_routes,
      ...saleManagementRoutes,
      ...wholesaleManagementRoutes,
      ...shopsaleManagementRoutes,
      ...wholesaleposManagementRoutes,
    ],
  },
  {
    path: '',
    loadComponent: () => import('./index/index.component').then(m => m.IndexComponent),
    data: {title: '首页'},
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
  },
];
